import { render } from "./BulkRefundsView.vue?vue&type=template&id=fd7e2280"
import script from "./BulkRefundsView.vue?vue&type=script&lang=js"
export * from "./BulkRefundsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__